import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { filter, firstValueFrom, take } from 'rxjs';
import { OnboardingStateService } from '@core/services/onboarding-state.service';
import { AuthService } from '../../services/AuthService';

const FORCE_ONBOARDING_KEY = 'hc.onboarding.force';

export const getStartedRedirectGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const onboardingState = inject(OnboardingStateService);
  const router = inject(Router);

  if (!authService.authReady()) {
    await firstValueFrom(
      authService.authReady$.pipe(
        filter((ready) => ready),
        take(1)
      )
    );
  }

  if (!authService.isAuthenticated()) {
    return true;
  }

  const forcedOnboarding = sessionStorage.getItem(FORCE_ONBOARDING_KEY) === '1';
  const completed = forcedOnboarding ? false : await onboardingState.checkOnboardingStatus();

  return completed ? router.parseUrl('/home') : router.parseUrl('/onboarding');
};
